import React from 'react';
import { secondDocumentOptions } from '@js/components/corporateRegistrations/Identification/constants';
import type {
  Category1,
  Category2
} from '@js/components/corporateRegistrations/Identification/types';


type Props = {
  documentKind: Category1 | Category2
};

export const IdentificationImageNote = ({ documentKind }: Props) => (
  <div className="form-file-block">
    <h3 className="form-file-block__heading">注意事項</h3>
    <ul className="list-base">
      {secondDocumentOptions[documentKind].notes.map(note => <li key={note} className="list-base__item">{note}</li>)}
      <li className="list-base__item">
        下記の例のように、ピントが合っている、全体が写っている、印字されている文字をしっかりと確認出来る写真をアップロードして下さい。
        <div className="form-file-block__example">
          <div className="form-example">
            <div className="form-example__body"><img alt="OKの例" src={`${import.meta.env.VITE_FINCF_APP_PUBLIC_CDN_HOST}/vite/img/img_example-good-a52647de21fd8ef9dbae780eb3306ec2.png`} /></div>

          </div>
          <div className="form-example">
            <div className="form-example__body"><img alt="NGの例" src={`${import.meta.env.VITE_FINCF_APP_PUBLIC_CDN_HOST}/vite/img/img_example-bad-526cc586cc93c4cacaed8ac7b4498f30.png`} /></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
);
